(()=>{
const scene=document.getElementById('scene'),timeEl=document.getElementById('time'),discEl=document.getElementById('discount'),foundEl=document.getElementById('found'),
start=document.getElementById('start'),end=document.getElementById('end'),final=document.getElementById('final'),result=document.getElementById('result'),
startBtn=document.getElementById('startBtn'),again=document.getElementById('again'),fullweb=document.getElementById('fullweb'),toast=document.getElementById('toast'),
claimBtn=document.getElementById('claimBtn'),claimBox=document.getElementById('claimBox'),claimCode=document.getElementById('claimCode'),
applyDiscount=document.getElementById('applyDiscount'),claimExpiry=document.getElementById('claimExpiry'),
dailyPlays=document.getElementById('dailyPlays'),coverDailyPlays=document.getElementById('coverDailyPlays'),
claimConfirm=document.getElementById('claimConfirm'),confirmClaimBtn=document.getElementById('confirmClaimBtn'),cancelClaimBtn=document.getElementById('cancelClaimBtn');

const API='https://intoresin-halloween-hunt.roger838178129.workers.dev';
const PLAYER_KEY='intoresin_halloween_player_v1';
const bgMusic = new Audio('https://cdn.shopify.com/s/files/1/0553/8181/9580/files/halloween_music.mp3?v=1789542297');
const normalFindSound = new Audio('https://cdn.shopify.com/s/files/1/0553/8181/9580/files/normal_finds.mp3?v=1789542296');
const rareFindSound = new Audio('https://cdn.shopify.com/s/files/1/0553/8181/9580/files/rare_finds.mp3?v=1789542296');

bgMusic.volume = 0.22;
normalFindSound.volume = 0.45;
rareFindSound.volume = 0.55;

bgMusic.loop = true;
const normalSoundPool = Array.from({length: 8}, () => {
  const audio = new Audio(normalFindSound.src);
  audio.volume = normalFindSound.volume;
  audio.preload = 'auto';
  audio.load();
  return audio;
});

const rareSoundPool = Array.from({length: 3}, () => {
  const audio = new Audio(rareFindSound.src);
  audio.volume = rareFindSound.volume;
  audio.preload = 'auto';
  audio.load();
  return audio;
});

let normalSoundIndex = 0;
let rareSoundIndex = 0;
function getPlayerId(){
  let id='';
  try{
    id=localStorage.getItem(PLAYER_KEY)||'';
  }catch(e){}

  if(!id){
    id=crypto.randomUUID
      ? crypto.randomUUID()
      : ('hunt-'+Date.now()+'-'+Math.random().toString(36).slice(2));

    try{
      localStorage.setItem(PLAYER_KEY,id);
    }catch(e){}
  }

  return id;
}

const playerId=getPlayerId();

let currentSessionId=null,
    playsRemaining=2,
    bestDiscount=0,
    claimed=false;
let running=false,
    seconds=30,
    discount=0,
    found=0,
    timer=null,
    ghostTimer=null,
    spiderTimer=null,
    potionTimer=null,
    eyeTimer=null,
    batTimer=null,
    catTimer=null,
    skullTimer=null,
    toastTimer=null,
    ents=[];

const spots=[
  [8,29,.60],[16,49,.56],[25,27,.58],[34,45,.54],[44,29,.56],
  [53,51,.52],[62,31,.55],[71,53,.52],[81,39,.53],[87,65,.50],
  [13,69,.50],[31,70,.49],[52,70,.48],[72,70,.48]
];

function msg(t){
  clearTimeout(toastTimer);
  toast.textContent=t;
  toast.classList.add('show');
  toastTimer=setTimeout(()=>toast.classList.remove('show'),800);
}

function pop(text,x,y,color){
  const d=document.createElement('div');
  d.className='reward';
  d.textContent=text;
  d.style.left=x+'px';
  d.style.top=y+'px';
  d.style.color=color;
  scene.appendChild(d);
  setTimeout(()=>d.remove(),850);
}

function add(n,x,y,label){
  if(!running)return;

  const before=discount;
  discount=Math.min(25,discount+n);
  const gained=discount-before;

  if(gained>0){
    found++;
    foundEl.textContent=found;
    discEl.textContent=discount+'%';
    pop('+'+gained+'%',x,y,gained>=5?'#ffd56a':'#8df2a7');
    msg(label);
  }else{
    msg('30% MAX');
  }
}

function makePumpkins(){
  const golden=Math.random()<.45
    ? Math.floor(Math.random()*spots.length)
    : -1;

  spots.forEach((s,i)=>{
    const b=document.createElement('button');

    b.className='hotspot'+(i===golden?' golden':'');
    b.style.left=`${s[0]}%`;
    b.style.top=`${s[1]}%`;
    b.style.opacity=s[2];
    b.innerHTML='<div class="pump"></div>';
    b.dataset.open='0';

    b.addEventListener('click',()=>{
      if(!running||b.dataset.open==='1')return;

      b.dataset.open='1';
      b.classList.add('opened');

      const r=b.getBoundingClientRect();
      const sr=scene.getBoundingClientRect();

      const x=r.left-sr.left+r.width/2;
      const y=r.top-sr.top+r.height/2;

      if(i===golden){
        add(5,x,y,'Golden Pumpkin +5%');
        return;
      }

      const roll=Math.random();

      if(roll<.56){
        add(1,x,y,'Candy +1%');
      }else if(roll<.72){
        add(2,x,y,'Rare Candy +2%');
      }else{
        msg('Empty...');
      }
    });

    scene.appendChild(b);
    ents.push(b);
  });
}

function spawnGhost(){
  if(!running)return;

  const g=document.createElement('div');
  const rare=Math.random()<.08;

  g.className='ghost'+(rare?' rare':'');
  g.innerHTML='<div class="gbody"></div>';

  scene.appendChild(g);
  ents.push(g);

  const sr=scene.getBoundingClientRect();
  const fromLeft=Math.random()<.5;

  let x=fromLeft?-60:sr.width+60;
  let y=130+Math.random()*(sr.height-300);
  let speed=260+Math.random()*180;
  let last=performance.now();
  let alive=true;
  let ttl=1700+Math.random()*700;
  let started=performance.now();

  g.style.top=y+'px';

  g.addEventListener('click',()=>{
    if(!running||!alive)return;

    alive=false;

    const r=g.getBoundingClientRect();

    add(
      rare?5:1,
      r.left-sr.left+r.width/2,
      r.top-sr.top+r.height/2,
      rare?'Rare Ghost +5%':'Ghost +1%'
    );

    g.remove();
  });

  function mv(ts){
    if(!running||!alive){
      if(g.isConnected)g.remove();
      return;
    }

    if(ts-started>ttl){
      alive=false;
      g.remove();
      return;
    }

    const dt=Math.min(.04,(ts-last)/1000);
    last=ts;

    x+=(fromLeft?1:-1)*speed*dt;
    g.style.left=x+'px';

    if(
      (fromLeft&&x>sr.width+70) ||
      (!fromLeft&&x<-70)
    ){
      alive=false;
      g.remove();
      return;
    }

    requestAnimationFrame(mv);
  }

  requestAnimationFrame(mv);
}

function spawnSpider(){
  if(!running)return;

  const s=document.createElement('div');
  s.className='spider';
  s.textContent='🕷️';

  const sr=scene.getBoundingClientRect();

  s.style.left=(25+Math.random()*(sr.width-70))+'px';
  s.style.top=(140+Math.random()*(sr.height-260))+'px';

  scene.appendChild(s);
  ents.push(s);

  s.addEventListener('click',()=>{
    if(!running)return;

    s.remove();
    fullweb.classList.add('show');
    msg('WEBBED!');

    setTimeout(
      ()=>fullweb.classList.remove('show'),
      1500
    );
  });

  setTimeout(()=>{
    if(s.isConnected)s.remove();
  },1320);
}

function spawnPotion(){
  if(!running)return;

  const p=document.createElement('div');
  const rare=Math.random()<.18;

  p.className='potion'+(rare?' rare':'');

  const sr=scene.getBoundingClientRect();

  p.style.left=(60+Math.random()*(sr.width-120))+'px';
  p.style.top=(150+Math.random()*(sr.height-300))+'px';

  scene.appendChild(p);
  ents.push(p);

  p.addEventListener('click',()=>{
    if(!running)return;

    const r=p.getBoundingClientRect();

    add(
      rare?3:1,
      r.left-sr.left+r.width/2,
      r.top-sr.top+r.height/2,
      rare?'Rare Potion +3%':'Potion +1%'
    );

    p.remove();
  });

  setTimeout(()=>{
    if(p.isConnected)p.remove();
  },2600);
}

function spawnEyeball(){
  if(!running)return;

  const e=document.createElement('div');
  e.className='eyeballjar';

  const sr=scene.getBoundingClientRect();

  e.style.left=(40+Math.random()*(sr.width-100))+'px';
  e.style.top=(155+Math.random()*(sr.height-300))+'px';

  scene.appendChild(e);
  ents.push(e);

  e.addEventListener('click',()=>{
    if(!running)return;

    const r=e.getBoundingClientRect();

    add(
      2,
      r.left-sr.left+r.width/2,
      r.top-sr.top+r.height/2,
      'Eyeball Found +2%'
    );

    e.remove();
  });

  setTimeout(()=>{
    if(e.isConnected)e.remove();
  },2200);
}

function spawnBat(){
  if(!running)return;

  const b=document.createElement('div');
  b.className='bat';
  b.textContent='🦇';

  scene.appendChild(b);
  ents.push(b);

  const sr=scene.getBoundingClientRect();
  const left=Math.random()<.5;

  let x=left?-45:sr.width+45;
  let y=120+Math.random()*(sr.height-270);
  let speed=310+Math.random()*170;
  let last=performance.now();
  let alive=true;

  b.style.top=y+'px';

  b.addEventListener('click',()=>{
    if(!running||!alive)return;

    alive=false;

    const r=b.getBoundingClientRect();

    add(
      1,
      r.left-sr.left+r.width/2,
      r.top-sr.top+r.height/2,
      'Bat +1%'
    );

    b.remove();
  });

  function fly(ts){
    if(!running||!alive){
      if(b.isConnected)b.remove();
      return;
    }

    const dt=Math.min(.04,(ts-last)/1000);
    last=ts;

    x+=(left?1:-1)*speed*dt;
    b.style.left=x+'px';

    if(
      (left&&x>sr.width+50) ||
      (!left&&x<-50)
    ){
      alive=false;
      b.remove();
      return;
    }

    requestAnimationFrame(fly);
  }

  requestAnimationFrame(fly);
}

function spawnCat(){
  if(!running)return;

  const c=document.createElement('div');
  c.className='cat';
  c.textContent='🐈‍⬛';

  const sr=scene.getBoundingClientRect();

  c.style.left=(30+Math.random()*(sr.width-90))+'px';
  c.style.top=(sr.height-165-Math.random()*65)+'px';

  scene.appendChild(c);
  ents.push(c);

  c.addEventListener('click',()=>{
    if(!running)return;

    const r=c.getBoundingClientRect();

    add(
      2,
      r.left-sr.left+r.width/2,
      r.top-sr.top+r.height/2,
      'Black Cat +2%'
    );

    c.remove();
  });

  setTimeout(()=>{
    if(c.isConnected)c.remove();
  },1700);
}

function spawnSkull(){
  if(!running)return;

  const k=document.createElement('div');
  k.className='skull';
  k.textContent='💀';

  const sr=scene.getBoundingClientRect();

  k.style.left=(30+Math.random()*(sr.width-90))+'px';
  k.style.top=(145+Math.random()*(sr.height-290))+'px';

  scene.appendChild(k);
  ents.push(k);

  k.addEventListener('click',()=>{
    if(!running)return;

    k.remove();

    seconds=Math.max(0,seconds-2);
    timeEl.textContent=seconds;

    msg('CURSED! −2 SEC');

    if(seconds<=0){
      finish();
    }
  });

  setTimeout(()=>{
    if(k.isConnected)k.remove();
  },1900);
}

function activateBrandFinds(){
  document.querySelectorAll('.brand-find').forEach(el=>{
    if(el.dataset.bound==='1')return;

    el.dataset.bound='1';

    el.addEventListener('click',()=>{
      if(
        !running ||
        el.classList.contains('used')
      )return;

      el.classList.add('used');

      const r=el.getBoundingClientRect();
      const sr=scene.getBoundingClientRect();

      const val=Number(
        el.dataset.brandReward||1
      );

      add(
        val,
        r.left-sr.left+r.width/2,
        r.top-sr.top+r.height/2,
        el.dataset.brandLabel ||
        ('IntoResin Find +'+val+'%')
      );
    });
  });
}

let popTimers=[];
let popTargets=[];
let resinDrops=0;

const DROPS_PER_PERCENT=5;

function updateDrops(){
  const c=document.getElementById('dropCount');
  const f=document.getElementById('dropFill');

  if(c){
    c.textContent=resinDrops+'/'+DROPS_PER_PERCENT;
  }

  if(f){
    f.style.width=
      (resinDrops/DROPS_PER_PERCENT*100)+'%';
  }
}

function flyDrops(x,y,n){
  const meter=document.getElementById('resinMeter');
  const sr=scene.getBoundingClientRect();
  const mr=meter
    ? meter.getBoundingClientRect()
    : null;

  const targetX=mr
    ? (mr.left-sr.left+18)
    : 30;

  const targetY=mr
    ? (mr.top-sr.top+mr.height/2)
    : 72;

  for(let i=0;i<n;i++){
    const d=document.createElement('span');

    d.className='drop-fly';
    d.textContent='💧';

    d.style.left=
      (x+(i-(n-1)/2)*12)+'px';

    d.style.top=y+'px';

    d.style.setProperty(
      '--drop-x',
      (targetX-(x+(i-(n-1)/2)*12))+'px'
    );

    d.style.setProperty(
      '--drop-y',
      (targetY-y)+'px'
    );

    scene.appendChild(d);

    setTimeout(()=>d.remove(),720);
  }
}

function addDrops(n,x,y,label){
  if(!running)return;

  resinDrops+=n;

  flyDrops(x,y,n);
  discovery(label+'  +'+n+' 💧',false);

  let gained=0;

  while(
    resinDrops>=DROPS_PER_PERCENT &&
    discount<25
  ){
    resinDrops-=DROPS_PER_PERCENT;
    gained++;
  }

  if(gained){
    const before=discount;

    discount=Math.min(
      25,
      discount+gained
    );

    gained=discount-before;

    discEl.textContent=discount+'%';

    pop(
      '+'+gained+'%',
      x,
      y,
      '#8df2a7'
    );

    pulseDiscount();

    const m=document.getElementById('resinMeter');

    if(m){
      m.classList.remove('meter-burst');
      void m.offsetWidth;
      m.classList.add('meter-burst');
    }
  }

  if(discount>=25){
    resinDrops=0;
  }

  updateDrops();
}

function addRareDiscount(n,x,y,label){
  if(!running)return;

  const before=discount;

  discount=Math.min(
    25,
    discount+n
  );

  const gained=discount-before;

  if(gained>0){
    discEl.textContent=discount+'%';

    pop(
      '+'+gained+'%',
      x,
      y,
      '#ffd56a'
    );

    pulseDiscount();

    discovery(
      '✦ '+label+'  +'+gained+'%',
      true
    );
  }
}

const popZones=[
  [8,24],[23,24],[39,25],[57,25],[74,25],
  [13,46],[30,47],[48,45],[66,47],[82,46],
  [9,68],[27,67],[45,68],[63,66],[80,67]
];

const popKinds=[
  {
    kind:'pumpkin',
    weight:34,
    min:1,
    max:2,
    label:'Candy Pumpkin'
  },
  {
    kind:'ghost',
    weight:19,
    min:1,
    max:2,
    label:'Ghost'
  },
  {
    kind:'potion',
    weight:16,
    min:1,
    max:3,
    label:'Potion'
  },
  {
    kind:'eye',
    weight:11,
    min:2,
    max:2,
    label:'Eyeball'
  },
  {
    kind:'bat',
    weight:11,
    min:1,
    max:1,
    label:'Bat'
  },
  {
    kind:'cat',
    weight:9,
    min:2,
    max:2,
    label:'Black Cat'
  }
];

function weightedKind(){
  let total=popKinds.reduce(
    (a,b)=>a+b.weight,
    0
  );

  let r=Math.random()*total;

  for(const k of popKinds){
    r-=k.weight;

    if(r<=0){
      return k;
    }
  }

  return popKinds[0];
}

function clearPopTimers(){
  popTimers.forEach(
    t=>clearTimeout(t)
  );

  popTimers=[];
}

function clearPopTargets(){
  popTargets.forEach(e=>{
    if(e&&e.isConnected){
      e.remove();
    }
  });

  popTargets=[];
}

function activePopCount(){
  return popTargets.filter(
    e=>
      e &&
      e.isConnected &&
      !e.classList.contains('hit')
  ).length;
}

function usedZones(){
  return popTargets
    .filter(
      e=>
        e &&
        e.isConnected &&
        !e.classList.contains('hit')
    )
    .map(
      e=>Number(e.dataset.zone)
    );
}

function pickZone(){
  const used=usedZones();

  const choices=popZones
    .map((_,i)=>i)
    .filter(
      i=>!used.includes(i)
    );

  return choices[
    Math.floor(
      Math.random()*choices.length
    )
  ];
}

function targetMarkup(kind){
  if(kind==='pumpkin'){
    return '<span class="pop-pumpkin"></span>';
  }

  if(kind==='ghost'){
    return '<span class="pop-ghost"></span>';
  }

  if(kind==='potion'){
    return '<span class="pop-potion"></span>';
  }

  if(kind==='eye'){
    return '<span class="pop-eye"></span>';
  }

  if(kind==='bat'){
    return '<span class="pop-bat">🦇</span>';
  }

  return '<span class="pop-cat">🐈‍⬛</span>';
}

function discovery(text,rare=false){
  const d=document.getElementById('discovery');

  if(!d)return;

  d.textContent=text;

  d.style.color=rare
    ? '#ffd56a'
    : '#f8f2ff';

  d.classList.remove('show');

  void d.offsetWidth;

  d.classList.add('show');
}

function particles(x,y,rare){
  const colors=rare
    ? ['#ffd56a','#d7ff92','#fff3b0']
    : ['#8df2a7','#d7c7ef','#ffb66f'];

  for(let i=0;i<9;i++){
    const q=document.createElement('i');

    q.className='pop-particle';

    q.style.left=x+'px';
    q.style.top=y+'px';

    q.style.background=
      colors[i%colors.length];

    const a=Math.random()*Math.PI*2;
    const d=28+Math.random()*48;

    q.style.setProperty(
      '--dx',
      Math.cos(a)*d+'px'
    );

    q.style.setProperty(
      '--dy',
      Math.sin(a)*d+'px'
    );

    scene.appendChild(q);

    setTimeout(
      ()=>q.remove(),
      620
    );
  }
}

function pulseDiscount(){
  discEl.classList.remove('discount-pulse');

  void discEl.offsetWidth;

  discEl.classList.add('discount-pulse');
}

function spawnPop(){
  if(
    !running ||
    activePopCount()>=6
  )return;

  const z=pickZone();

  if(z===undefined)return;

  const spec=weightedKind();

  const rare=Math.random()<.035;

  const drops=
    1+
    (Math.random()<.24?1:0)+
    (Math.random()<.04?1:0);

  const rareBonus=
    Math.random()<.85
      ? 2
      : 3;

  const el=document.createElement('button');

  el.className=
    'pop-target'+
    (rare?' pop-rare':'');

  el.dataset.zone=z;

  el.style.left=
    popZones[z][0]+'%';

  el.style.top=
    popZones[z][1]+'%';

  el.innerHTML=
    targetMarkup(spec.kind);

  scene.appendChild(el);

  popTargets.push(el);

  const life=
    spec.kind==='ghost' ||
    spec.kind==='bat' ||
    spec.kind==='cat'
      ? 2300
      : 3600;

  el.addEventListener('click',()=>{
    if(
      !running ||
      el.classList.contains('hit')
    )return;

    el.classList.add('hit');

    found++;

    foundEl.textContent=found;

    const r=el.getBoundingClientRect();
    const sr=scene.getBoundingClientRect();

    const x=
      r.left-sr.left+r.width/2;

    const y=
      r.top-sr.top+r.height/2;

    if(rare){
const rareSound = rareSoundPool[rareSoundIndex];
rareSoundIndex = (rareSoundIndex + 1) % rareSoundPool.length;
rareSound.currentTime = 0;
rareSound.play().catch(()=>{});
      addRareDiscount(
        rareBonus,
        x,
        y,
        'RARE '+spec.label
      );
    }else{
const normalSound = normalSoundPool[normalSoundIndex];
normalSoundIndex = (normalSoundIndex + 1) % normalSoundPool.length;
normalSound.currentTime = 0;
normalSound.play().catch(()=>{});
      addDrops(
        drops,
        x,
        y,
        spec.label
      );
    }

    particles(x,y,rare);

    setTimeout(()=>{
      el.remove();
      spawnPop();
    },250);
  });

  const t=setTimeout(()=>{
    if(
      el.isConnected &&
      !el.classList.contains('hit')
    ){
      el.animate(
        [
          {opacity:1},
          {opacity:0}
        ],
        {
          duration:220,
          fill:'forwards'
        }
      );

      setTimeout(()=>{
        el.remove();

        if(running){
          spawnPop();
        }
      },210);
    }
  },life);

  popTimers.push(t);
}

function startPopLoop(){
  scene.classList.add('pop-mode');

  clearPopTimers();
  clearPopTargets();

  for(let i=0;i<5;i++){
    const t=setTimeout(
      spawnPop,
      180+i*210
    );

    popTimers.push(t);
  }

  const refill=()=>{
    if(!running)return;

    while(activePopCount()<5){
      spawnPop();
    }

    const t=setTimeout(
      refill,
      650
    );

    popTimers.push(t);
  };

  popTimers.push(
    setTimeout(
      refill,
      1500
    )
  );
}

function stopPopLoop(){
  scene.classList.remove('pop-mode');

  clearPopTimers();
  clearPopTargets();
}

function clearEnts(){
  ents.forEach(e=>{
    try{
      e.remove();
    }catch{}
  });

  ents=[];
}

function reset(){
  stopPopLoop();
claimed=false;
claimBtn.classList.remove('hidden');
claimBox.classList.add('hidden');
  document
    .querySelectorAll('.brand-find')
    .forEach(
      el=>el.classList.remove('used')
    );

  clearInterval(timer);
  clearInterval(ghostTimer);
  clearInterval(spiderTimer);
  clearInterval(potionTimer);
  clearInterval(eyeTimer);
  clearInterval(batTimer);
  clearInterval(catTimer);
  clearInterval(skullTimer);

  clearEnts();

  fullweb.classList.remove('show');

  seconds=30;
  discount=0;
  found=0;

  timeEl.textContent='30';
  discEl.textContent='0%';
  foundEl.textContent='0';
}

function paintServerState(){
  const n=Math.max(
    0,
    Number(playsRemaining)||0
  );

  const txt=n===0
    ? 'You have used all 2 plays today. Come back tomorrow.'
    : 'You have '+n+' play'+(n===1?'':'s')+' left today';

  if(dailyPlays){
    dailyPlays.textContent=txt;
  }

  if(coverDailyPlays){
    coverDailyPlays.textContent=txt;
  }

  if(startBtn){
    startBtn.disabled=n===0;
    startBtn.style.opacity=
      n===0
        ? '.45'
        : '1';
  }

  if(again){
    again.disabled=n===0;
    again.style.opacity=
      n===0
        ? '.45'
        : '1';
  }
}

async function apiPost(path,body){
  const r=await fetch(
    API+path,
    {
      method:'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body:JSON.stringify(body||{})
    }
  );

  const data=await r
    .json()
    .catch(
      ()=>({
        success:false,
        error:'INVALID_RESPONSE'
      })
    );

  if(
    !r.ok &&
    !data.error
  ){
    data.error='HTTP_'+r.status;
  }

  return data;
}

async function refreshStatus(){
  try{
    const s=await apiPost(
      '/api/status',
      {playerId}
    );

    if(s.success){
      playsRemaining=s.playsRemaining;
      bestDiscount=s.bestDiscount||0;

      paintServerState();
    }
  }catch(e){
    if(coverDailyPlays){
      coverDailyPlays.textContent=
        'Unable to check plays. Please try again.';
    }
  }
}

async function begin(e){
  if(running)return;
  bgMusic.currentTime = 0;
bgMusic.play().catch(()=>{});
  const clickedBtn=e?.currentTarget;

if(clickedBtn){
  clickedBtn.classList.add('button-clicked');
}

  startBtn.disabled=true;

  if(again){
    again.disabled=true;
  }

  let s;

  try{
    s=await apiPost(
      '/api/start',
      {playerId}
    );
  }catch(e){
    msg('Connection error — try again');
    paintServerState();
    return;
  }

  if(!s.success){
    if(
      s.error==='DAILY_LIMIT_REACHED'
    ){
      playsRemaining=0;
      paintServerState();
      msg('Daily play limit reached');
    }else{
      msg('Unable to start — try again');
    }

    return;
  }

  currentSessionId=s.sessionId;
  playsRemaining=s.playsRemaining;

  paintServerState();

  reset();

  resinDrops=0;
  updateDrops();

  running=true;

  start.classList.add('hidden');
  end.classList.add('hidden');

  startPopLoop();

  timer=setInterval(()=>{
    seconds--;

    timeEl.textContent=seconds;

    if(seconds<=0){
      finish();
    }
  },1000);
}

async function finish(){
  if(!running)return;

  running=false;

  stopPopLoop();
scene.classList.add('pop-mode')
  clearInterval(timer);
  clearInterval(ghostTimer);
  clearInterval(spiderTimer);
  clearInterval(potionTimer);
  clearInterval(eyeTimer);
  clearInterval(batTimer);
  clearInterval(catTimer);
  clearInterval(skullTimer);

  clearEnts();

  fullweb.classList.remove('show');


  claimBtn.disabled=true;


  claimBox.classList.add('hidden');
  const instantBest=Math.max(bestDiscount,discount);
final.innerHTML=
  '<span class="reward-current">'+discount+'% OFF</span>'+
  '<span class="reward-label reward-best-label">YOUR BEST REWARD</span>'+
  '<span class="reward-value">'+instantBest+'% OFF</span>';
end.classList.remove('hidden');
  try{
    const s=await apiPost(
      '/api/finish',
      {
        playerId,
        sessionId:currentSessionId,
        discount
      }
    );

    if(s.success){
      bestDiscount=
        s.bestDiscount||discount;

      result.textContent=
        `You found ${found} Halloween surprises. Today's best reward is ${bestDiscount}% OFF.`;

      claimBtn.textContent=
        'CLAIM MY '+
        bestDiscount+
        '% OFF';

      claimBtn.disabled=false;
    }else{
      result.textContent=
        'Your hunt finished, but the reward could not be saved. Please try again.';

      claimBtn.textContent=
        'REWARD NOT SAVED';
    }
  }catch(e){
    result.textContent=
      'Connection error while saving your reward. Please try again.';

    claimBtn.textContent=
      'REWARD NOT SAVED';
  }

  await refreshStatus();
}
function claimReward(){
  if(claimed)return;

  if(playsRemaining === 0){
    confirmClaimReward();
    return;
  }

  confirmClaimBtn.textContent=
    'CLAIM '+bestDiscount+'% OFF';

  claimConfirm.classList.remove('hidden');
}
async function confirmClaimReward(){
  if(claimed)return;

  claimBtn.disabled=true;

  claimBtn.textContent=
    'CREATING YOUR CODE...';

  try{
    const c=await apiPost(
      '/api/claim',
      {playerId}
    );

    if(!c.success){
      claimBtn.disabled=false;

      claimBtn.textContent=
        'TRY CLAIM AGAIN';

      msg(
        'Could not create discount code'
      );

      return;
    }

    claimed=true;

    claimBtn.classList.add('hidden');

    claimBox.classList.remove('hidden');

    claimCode.textContent=c.code;

    applyDiscount.textContent=
      'APPLY '+
      c.discount+
      '% OFF';

    applyDiscount.href=
      c.applyUrl;

    const exp=
      new Date(c.expiresAt);

    claimExpiry.textContent=
      'Valid for 24 hours · Expires '+
      exp.toLocaleString();

  }catch(e){
    claimBtn.disabled=false;

    claimBtn.textContent=
      'TRY CLAIM AGAIN';

    msg(
      'Connection error — try again'
    );
  }
}

function playCoverIntro(){
  console.log('DEBUG: playCoverIntro started')
  const drip=
    document.getElementById('dripSource');

  const impact=
    document.getElementById('impact');

  const title=
    document.getElementById('coverTitle');

  const after=
    document.getElementById('coverAfter');

  const sparks=
    document.querySelectorAll('.spark');

  if(
    !drip ||
    !impact ||
    !title ||
    !after
  )return;

  drip.classList.remove('run');
  impact.classList.remove('boom');
  title.classList.remove('reveal');
  after.classList.remove('show');

  sparks.forEach(
    x=>x.classList.remove('fly')
  );

  void drip.offsetWidth;

  setTimeout(
    ()=>drip.classList.add('run'),
    120
  );

  setTimeout(()=>{
    impact.classList.add('boom');

    sparks.forEach(
      x=>x.classList.add('fly')
    );
  },1500);

  setTimeout(
    ()=>title.classList.add('reveal'),
    1570
  );

setTimeout(
  ()=>after.classList.add('show'),
  2150
);
}

setTimeout(
  playCoverIntro,
  120
);

startBtn.addEventListener(
  'click',
  begin
);

again.addEventListener(
  'click',
  begin
);

claimBtn.addEventListener(
  'click',
  claimReward
);
confirmClaimBtn.addEventListener(
  'click',
  ()=>{
    claimConfirm.classList.add('hidden');
    confirmClaimReward();
  }
);

cancelClaimBtn.addEventListener(
  'click',
  ()=>{
    claimConfirm.classList.add('hidden');
    end.classList.add('hidden');
    begin();
  }
);
refreshStatus();
})()